// extracted by mini-css-extract-plugin
export default {"root":"UserTooltip_root__9Od9U","avatar":"UserTooltip_avatar__tfALa"};